import React from 'react';
// import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title: string;
  description: string;
  keywords?: string[];
  image?: string;
  url?: string;
  type?: 'website' | 'article';
  publishedTime?: string;
  modifiedTime?: string;
}

export const SEO: React.FC<SEOProps> = ({
  title,
  description,
  keywords = [],
  image = '/images/og-default.jpg',
  url = 'https://getwishful.com',
  type = 'website',
  publishedTime,
  modifiedTime
}) => {
  // Temporarily disabled SEO component for React 19 compatibility
  // const fullTitle = `${title} | Wishful - Free Wishlist & Gift Planning Tools`;
  
  return null;
};

